import * as React from 'react';

import { createIcon } from '../Icon';
export const BookmarkIcon = createIcon(
  <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />,
  'BookmarkIcon'
);
